import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";
import {PointsData} from "../points.data";

@Component({
    selector: "wbo-member-loyalty-accrual-type-single-select-column",
    templateUrl: "../../../framework/entity/edit/edit-grid/columns/single-select-column.component.html",
    providers: [
        {
            provide: ColumnComponent,
            useExisting: forwardRef(() => MemberLoyaltyAccrualTypeSingleSelectColumnComponent),
            multi: true
        }
    ]
})
export class MemberLoyaltyAccrualTypeSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent {
    @Input() membershipTypeField: string;

    constructor(injector: Injector) {
        super(injector);

        this.buildData([
            {label: "wbo.member-loyalty.option.accrual-redemption-type.none", value: PointsData.TYPE_NONE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perDollar", value: PointsData.TYPE_PER_DOLLAR},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnitAtAnyPrice", value: PointsData.TYPE_PER_UNIT_AT_ANY_PRICE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnitAtFullPrice", value: PointsData.TYPE_PER_UNIT_AT_FULL_PRICE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnitUnlessFree", value: PointsData.TYPE_PER_UNIT_UNLESS_FREE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnitProRata", value: PointsData.TYPE_PER_UNIT_PRO_RATA}
        ]);
    }

    override getClearSelectionOptionLabel(entity: EntityData<any>): string {
        return this.getPlaceholder(entity);
    }

    override getPlaceholder(entity: EntityData<any>): string {
        if (!this.membershipTypeField || !entity[this.membershipTypeField]) {
            return undefined;
        } else if (entity[this.membershipTypeField].membershipTypeId == undefined) {
            return "wbo.member-loyalty.option.accrual-redemption-type.asPerMembershipType";
        } else {
            return "wbo.member-loyalty.option.accrual-redemption-type.productDefault";
        }
    }
}
